<template>
	<div>
		<!-- :img-src="`http://www.difarmer.com/imagenes/BannersWeb/${item.idBannersImagen}.jpg` " -->
		<b-carousel :interval="4000" img-height="480" indicators v-model="index">
			<b-carousel-slide
				:img-src="imagenOptima(item.idBannersImagen)"
				:key="item.idBanner"
				@click.native="click"
				v-for="item in items"
				class="cursor-pointer"
			></b-carousel-slide>
		</b-carousel>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				index: 0
			}
		},
		props: ["items"],
		methods: {
			click() {
				this.$emit("clickItem", this.items[this.index])
			},
			imagenOptima(item){
				//console.log('ITEM:',item)
				return 'http://www.difarmer.com/imagenes/BannersWeb/' + item + this.imgExtension()
			},
			
		}
	}
</script>


<style scoped>
</style>

